import { Box, Button, Grid, Typography } from "@material-ui/core"
import { AssinaturaFragment } from "./assinatura-fragment/assinatura-fragment"
import { useCallback, useRef } from "react";
import { usePutConfirmarRecebimento } from "../../../../../data/api/gestao/processo-produto-setor/put-confirmar-recebimento";
import { KdsStorageKeys, useKdsStorage, useSessaoAtual, useToastSaurus } from "../../../../../services/app";
import { ConfirmarEntregaModel } from "../../../../../model/app/forms/confirmar-entrega/confirmar-entrega-model";
import { ConfirmarRecebimentoModel } from "../../../../../model/api/processo-produto-setor/confirmar-recebimento";
import { useHistory, useLocation } from "react-router-dom";
import { CircularLoading } from "../../../../components";
import { ConfirmarIcon } from "../../../../components/icons/confirmar-icon";
import SignatureCanvas from "react-signature-canvas";
import { LimparIcon } from "../../../../components/icons/limpar-icon";
import { useThemeQueries } from "../../../../theme";
import { useConfirm } from "material-ui-confirm";
import { PedidoModel } from "../../../../../model/api/pedidos/pedido-model";
import { usePedidos } from "../../../../../hooks/pedidos";
import { ModuloModel } from "../../../../../model/app/forms/master/modulo-model";
import { EnumModulo } from "../../../../../model/enums/enum-modulo";
import { useStyles } from "./assinatura-entrega-data-styles";
import { ActionQueryModel } from "../../../../../model/app/master/action-query-model";
import { useAbrirApp } from "../../../../../hooks/abrir-app";
import { EnumCodigosPermissoes } from "../../../../../model/enums/enum-codigos-permissoes";
import { VariaveisAmbiente } from "../../../../../config";
import { comprimirUrl } from "../../../../../utils/comprimir-dados";

export const AssinaturaEntregaData = () => {

    const { showToast } = useToastSaurus();
    const { getRegistro } = useKdsStorage()
    const history = useHistory();
    const location = useLocation()
    const { theme } = useThemeQueries();
    const modulo = getRegistro(KdsStorageKeys.SelecaoModulo, false) as ModuloModel;
    const state = location.state as { pedido?: PedidoModel | undefined, processo?: ConfirmarEntregaModel } | undefined;
    const classes = useStyles()
    const { abrirApp } = useAbrirApp()
    const { getPermissaoBoolean } = useSessaoAtual()

    const padRef = useRef<{ getValue: () => SignatureCanvas, clear: () => void }>(null);

    const { putConfirmarRecebimento, carregando: carregandoConfirmarRecebimento } = usePutConfirmarRecebimento();
    const { getEmpresaSelecionada, carregando: carregandoSessaoAtual } = useSessaoAtual();
    const { concluirPedidoEntrega, carregando: carregandoConcluir } = usePedidos()
    const confirm = useConfirm()

    const carregando = carregandoConfirmarRecebimento || carregandoSessaoAtual || carregandoConcluir;

    const putConfirmarRecebimentoWrapper = useCallback(async () => {
        try {
            const confirmar = new ConfirmarRecebimentoModel();
            const getSignature = padRef?.current?.getValue?.()
            const dataSignature = getSignature?.toDataURL()
            const isDataEmpty = getSignature?.isEmpty()
            if (isDataEmpty)
                throw new Error('Assinatura inválida.')
            confirmar.ids = state?.processo?.processosProdutosIds || [];
            confirmar.imagemDados = dataSignature ?? '';
            const proximoProcesso = (state?.processo?.processoAtual || 0) + 1;

            await confirm({
                title: 'Confirmação',
                content: <div>Confirma a entrega do pedido <Box component="span" fontWeight="bold">{state?.processo?.codigoPedido}</Box>?</div>
            })
            const res = await putConfirmarRecebimento(getEmpresaSelecionada()?.Id!, proximoProcesso, confirmar);

            if (res.erro)
                throw res.erro
            history.push('/')
            showToast('success', 'Entrega realizada com sucesso.');
        } catch (err: any) {
            if (err?.message) {
                showToast('error', err?.message);
            }
        }
    }, [confirm, getEmpresaSelecionada, history, state?.processo?.codigoPedido, state?.processo?.processoAtual, state?.processo?.processosProdutosIds, putConfirmarRecebimento, showToast])

    const handleIniciarVenda = async () => {
        const query: ActionQueryModel<{ pedidoId: string }> = {
            type: 'importarPedidoById',
            query: {
                pedidoId: state?.pedido?.id ?? '',
            },
            backTo: VariaveisAmbiente.packageNameKds,
        }

        const actionStr = comprimirUrl(JSON.stringify(query))

        abrirApp(VariaveisAmbiente.packageNamePdv, actionStr)
        return true
    }

    const putConfirmarEntregaPedido = async () => {
        const model = state?.pedido;
        const getSignature = padRef?.current?.getValue?.()
        const dataSignature = getSignature?.toDataURL()
        const isDataEmpty = getSignature?.isEmpty()
        if (isDataEmpty)
            throw new Error('Assinatura inválida.')

        if (!getPermissaoBoolean(EnumCodigosPermissoes.REALIZAR_VENDAS)) {
            confirm({
                title: 'Confirmação',
                content: <div>Confirma a entrega do pedido <Box component="span" fontWeight="bold">{model?.codigoPedido}</Box>?</div>,
                confirmationButtonProps: {
                    color: 'primary',
                    variant: 'contained',
                },
                confirmationText: 'Entregar',
                cancellationText: 'Cancelar',
            })
                .then(async () => {
                    try {
                        await concluirPedidoEntrega(model?.id!, dataSignature)
                        history.push('/')
                    } catch (err: any) {
                        showToast('error', err.message);
                        return
                    }
                })
                .catch(() => {
                })
            return
        }

        confirm({
            title: 'Confirmar a entrega do pedido',
            description: 'Você pode apenas marcar como entregue ou, se preferir, finalizar a venda agora. Deseja finalizar a venda?',
            confirmationButtonProps: {
                color: 'primary',
                variant: 'contained',
            },
            cancellationText: 'Entregar',
            confirmationText: 'Finalizar venda'
        })
            .then(async () => {
                try {
                    await concluirPedidoEntrega(model?.id!, dataSignature)
                    await handleIniciarVenda()
                    history.push('/')
                } catch (err: any) {
                    showToast('error', err.message);
                    return
                }
            })
            .catch(async () => {
                try {
                    await concluirPedidoEntrega(model?.id!, dataSignature)
                    showToast('success', 'Entrega realizada com sucesso.');
                } catch (err: any) {
                    showToast('error', err.message);
                    return
                }
                history.push('/')
            })
    }

    const confirmarRecebimento = async () => {
        try {
            if (modulo.modulo === EnumModulo.Motoboy) {
                await putConfirmarEntregaPedido()
                return
            }
            await putConfirmarRecebimentoWrapper();
        } catch (err: any) {
            showToast('error', err.message);
        }
    }

    const limparAssinatura = useCallback(() => {
        padRef?.current?.clear();
    }, [])

    return (
        <>
            {carregando && <CircularLoading tipo="FULLSIZED" />}
            <Grid container style={{
                padding: '8px',
                height: '100%'
            }}>
                <Grid item xs={12} style={{ height: '100%' }}>
                    <Grid container spacing={2} style={{ height: '100%' }}>
                        <Grid item xs={12} style={{
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <Typography
                                variant="body1"
                                color="textPrimary"
                                className={classes.textAssinatura}
                            >
                                Para confirmar a entrega do pedido solicitado,
                                é necessácio a assinatura do cliente.
                            </Typography>
                        </Grid>
                        <Grid item xs={12} className={classes.contentAssinatura}>
                            <AssinaturaFragment
                                ref={padRef}
                            />
                        </Grid>
                        <Grid item xs={6} className={classes.gridBtn}>
                            <Button
                                variant='outlined'
                                color={'primary'}
                                fullWidth={true}
                                onClick={() => limparAssinatura()}
                                startIcon={<LimparIcon tipo="BUTTON_PRIMARY" fill={theme.palette.primary.main} />}
                                style={{
                                    background: '#FFF'
                                }}
                            >
                                Limpar
                            </Button>
                        </Grid>
                        <Grid item xs={6} className={classes.gridBtn}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth={true}
                                onClick={confirmarRecebimento}
                                startIcon={<ConfirmarIcon tipo="BUTTON_PRIMARY" />}
                                style={{
                                    padding: '8px'
                                }}
                            >
                                Confirmar
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}